import React from "react";

import { toTitleCase } from "../constants";

const CategoryTabs = ({ categories, selectedCategory, onCategoryChange }) => {
  if (!categories || categories.length === 0) return null;

  return (
    <div className="flex items-center gap-3">
        {categories.map((category) => (
          <button
            key={category._id}
            className={`flex h-[40px] padding-[8px_16px] justify-center items-center gap-2 rounded-full px-4 text-sm font-medium transition-all 
              ${selectedCategory === category.label
              ? "bg-[#001A2A] text-[#00E7FF] rounded-full"
              : "text-app-text-muted hover:text-app-accent"}`
            }
            onClick={() => onCategoryChange(category.label)}
          >
            {toTitleCase(category.label)}
          </button>
        ))}
      </div>
  );
};

export default CategoryTabs;
